/**
 * Compute if the device is a tablet-like device
 * @returns True if the device is a tablet-like device, false otherwise
 */
export const checkIfTouchDevice = () => {
	return "ontouchstart" in window || navigator.maxTouchPoints > 0;
};
